import { render, staticRenderFns } from "./Gerais.vue?vue&type=template&id=00c576eb&scoped=true&"
import script from "./Gerais.vue?vue&type=script&lang=js&"
export * from "./Gerais.vue?vue&type=script&lang=js&"
import style0 from "./Gerais.vue?vue&type=style&index=0&id=00c576eb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c576eb",
  null
  
)

export default component.exports